//region :: Imports ::
import {ReactElement} from 'react';
import MComponent from '../Component';
import {BlockUI, BlockUITemplateType} from 'primereact/blockui';
import {evalulateBool, MBoolean} from './Control';

//endregion

/** */
export type MBlockUIRTProps = {
    locked: MBoolean;
}

/** */
type Props = MBlockUIRTProps & {
    fullscreen?: boolean;
    template?: BlockUITemplateType;
    children: JSX.Element | JSX.Element[] | string;
}

/** */
class MBlockUI extends MComponent<Props> {

    /** */
    public render(): ReactElement {

        return (
            <BlockUI blocked={evalulateBool(this.props.locked)}
                     fullScreen={this.props.fullscreen}
                     template={this.props.template}>

                {this.props.children}

            </BlockUI>
        );

    }

}

export default MBlockUI;
